// Simple analytics tracking function
function Analytics() {
  const analytics = {
    sessionStart: Date.now(),
    events: [],
    pageViews: [],

    // Initialize analytics
    init() {
      this.loadFromStorage()
      console.log('Analytics initialized')
    },

    // Track page views
    trackPageView(page, path = window.location.pathname) {
      const event = {
        type: 'pageView',
        page,
        path,
        timestamp: Date.now(),
        userAgent: navigator.userAgent,
        referrer: document.referrer,
        url: window.location.href
      }
      
      this.pageViews.push(event)
      this.saveToStorage()
      console.log('Page view tracked:', page)
    },

    // Track custom events
    trackEvent(eventName, data = {}) {
      const event = {
        type: 'event',
        name: eventName,
        data,
        timestamp: Date.now(),
        url: window.location.href
      }
      
      this.events.push(event)
      this.saveToStorage()
      console.log('Event tracked:', eventName, data)
    },

    // Track performance metrics
    trackPerformance() {
      if (typeof window === 'undefined' || !window.performance) return

      const navigation = performance.getEntriesByType('navigation')[0]
      if (!navigation) return

      const metrics = {
        type: 'performance',
        loadTime: navigation.loadEventEnd - navigation.loadEventStart,
        domContentLoaded: navigation.domContentLoadedEventEnd - navigation.domContentLoadedEventStart,
        timestamp: Date.now()
      }

      this.events.push(metrics)
      this.saveToStorage()
      console.log('Performance tracked:', metrics)
    },

    // Setup scroll depth tracking
    setupScrollTracking() {
      let maxScroll = 0
      const trackScroll = () => {
        const scrollPercent = Math.round(
          (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100
        )
        
        if (scrollPercent > maxScroll) {
          maxScroll = scrollPercent
          
          if (scrollPercent >= 25 && maxScroll < 25) {
            this.trackEvent('Scroll Depth', { depth: '25%' })
          } else if (scrollPercent >= 50 && maxScroll < 50) {
            this.trackEvent('Scroll Depth', { depth: '50%' })
          } else if (scrollPercent >= 75 && maxScroll < 75) {
            this.trackEvent('Scroll Depth', { depth: '75%' })
          } else if (scrollPercent >= 90 && maxScroll < 90) {
            this.trackEvent('Scroll Depth', { depth: '90%' })
          }
        }
      }

      window.addEventListener('scroll', trackScroll, { passive: true })
      return () => window.removeEventListener('scroll', trackScroll)
    },

    // Save data to localStorage
    saveToStorage() {
      try {
        localStorage.setItem('orifel_analytics', JSON.stringify({
          events: this.events,
          pageViews: this.pageViews,
          sessionStart: this.sessionStart
        }))
      } catch (error) {
        console.warn('Failed to save analytics data:', error)
      }
    },

    // Load data from localStorage
    loadFromStorage() {
      try {
        const data = localStorage.getItem('orifel_analytics')
        if (data) {
          const parsed = JSON.parse(data)
          this.events = parsed.events || []
          this.pageViews = parsed.pageViews || []
          this.sessionStart = parsed.sessionStart || Date.now()
        }
      } catch (error) {
        console.warn('Failed to load analytics data:', error)
      }
    },

    // Get analytics report
    getReport() {
      return {
        events: this.events,
        pageViews: this.pageViews,
        sessionDuration: Date.now() - this.sessionStart,
        totalEvents: this.events.length,
        totalPageViews: this.pageViews.length
      }
    }
  }

  return analytics
}

// SEO optimization functions
export const updateMetaTags = (title, description, keywords = '') => {
  document.title = title
  
  const metaDescription = document.querySelector('meta[name="description"]')
  if (metaDescription) {
    metaDescription.content = description
  }
  
  if (keywords) {
    let metaKeywords = document.querySelector('meta[name="keywords"]')
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta')
      metaKeywords.name = 'keywords'
      document.head.appendChild(metaKeywords)
    }
    metaKeywords.content = keywords
  }
}

export const updateOpenGraphTags = (title, description, imageUrl = '') => {
  const updateOGTag = (property, content) => {
    let tag = document.querySelector(`meta[property="${property}"]`)
    if (!tag) {
      tag = document.createElement('meta')
      tag.setAttribute('property', property)
      document.head.appendChild(tag)
    }
    tag.content = content
  }

  updateOGTag('og:title', title)
  updateOGTag('og:description', description)
  updateOGTag('og:url', window.location.href)
  updateOGTag('og:type', 'website')
  
  if (imageUrl) {
    updateOGTag('og:image', imageUrl)
  }
}

// Export Analytics class as default
export default Analytics
